<template>
  <div>
    <div class="content">
      <div class="title">
        <span>处方信息</span>
      </div>
      <ul>
        <li>
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>科室：</span>
            <span>{{ orderInfo.creatorDeptName }}</span>
          </p>
        </li>
      </ul>
      <div class="title">
        <span>处方明细</span>
      </div>
      <van-row align="center" style="margin-top: 5px;">
        <van-col>
          <span style="margin-left:15px;margin-right:60px">{{ orderInfo.goodsName }}</span>
          <span style="margin-right:60px">{{ orderInfo.number }}{{ orderInfo.specifications }}</span>
          <span style="margin-right:50px">￥{{ orderInfo.goodsPrice }}/{{ orderInfo.specifications }}</span>
        </van-col>
      </van-row>

      <div class="title">
        <span>处方金额</span>
      </div>
      <div class="totalContent">
        <p>
          <span style="color: var(--basic-green)">金额：</span>
          <span>￥{{ orderInfo.totalAmount || 0 }}</span>
          <!-- <span v-if="orderInfo.orderStatus === 1" style="color: var(--basic-red)">
              未缴费
            </span>
            <span v-if="orderInfo.orderStatus === 2" style="color: var(--basic-red)">
              支付中
            </span>
            <span v-if="orderInfo.orderStatus === 3" style="color: var(--basic-green)">
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span> -->
        </p>
      </div>
      <div class="title">
        <span>支付信息</span>
      </div>
      <van-form @submit="onSubmit">
        <van-row align="center">
          <van-col span="5" style="margin-left: 15px;">
            <span style="color: var(--basic-labe);">姓名</span>
          </van-col>
          <van-col span="18">
            <van-field :rules="[{ required: true, message: '请填写姓名' }]" v-model="form.name" placeholder="请输入姓名" />
          </van-col>
        </van-row>
        <van-row align="center">
          <van-col span="2" style="margin-left: 15px;">
            <span style="color: var(--basic-labe);">床号</span>
          </van-col>
          <van-col span="5" style="margin-left: 0px;">
            <div class="titleMessage">
              <span>楼层</span>
            </div>
            <div class="titleMessage">
              <span>床号</span>
            </div>
            <div class="titleMessage">
              <span>手机号</span>
            </div>
          </van-col>
          <van-col span="10">
            <van-row align="center">
              <van-field :rules="[{ required: true, message: '请填写您的住院楼层' }]" v-model="form.floor"
                placeholder="请填写您的住院楼层" />
            </van-row>
            <van-row align="center">
              <van-field label="" :rules="[{ required: true, message: '填写您的住院床号' }]" v-model="form.bedNumber"
                placeholder="填写您的住院床号" />
            </van-row>
            <van-row align="center">
              <van-field :rules="[{ required: true, message: '请填写您的手机号' }]" v-model="form.phone" placeholder="请填写您的手机号" />
            </van-row>
          </van-col>
        </van-row>
      </van-form>
      <div>
        <div class="btnContent">
          <van-button v-if="orderInfo.orderStatus === 1" @click="payment" round size="small" type="success">
            立即支付
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  requestGoodsPrescription,
  requestGetJsticket,
  generatePatientSubmit
} from "@/api/prescription/prescription";
import { reactive, toRefs } from "vue";
import { Toast } from "vant";

import { useRoute } from "vue-router";
import moment from "moment/moment";

export default {
  mounted() {


  },
  methods: {

  },
  setup() {
    const route = useRoute();
    const state = reactive({
      orderInfo: "",
      medicalAdviceCode: route.query.adviceCode,
      category: route.query.category,
      content: route.query.c,
      code: route.query.o,
      form: {}
    });

    // 获取支付信息接口
    requestGoodsPrescription({
      c: state.content,
      o: state.code,
    }).then((v) => {
      const { data } = v;
      state.orderInfo = data;
      state.paymentAddress = data.paymentUrl;
      state.orderInfo.createTime = moment(state.orderInfo.createTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2);
    });
    // 支付方法
    const payment = () => {
      let param = {
        medicalAdviceCode: state.orderInfo.medicalAdviceCode,
        name: state.form.name,
        floor: state.form.floor,
        bedNumber: state.form.bedNumber,
        phone: state.form.phone
      }
      if (!param.name) {
        Toast("请填写姓名");
        return;
      }
      if (!param.floor) {
        Toast("请填写楼层");
        return;
      }
      if (!param.bedNumber) {
        Toast("请填写床号");
        return;
      }
      if (!param.phone) {
        Toast("请填写手机号");
        return;
      } else {
        generatePatientSubmit(param).then(() => {
          window.location.href = state.paymentAddress;
        }).catch((error) => {
          console.log(error);
        });
      }



    };

    return {
      ...toRefs(state),
      payment,
      requestGoodsPrescription,
      requestGetJsticket,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;

  .totalContent {
    .title {
      opacity: 0.5;
    }

    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;

      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }

  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }

  .titleMessage {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);
    float: right;

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-red);
    }
  }

  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);

      span:first-of-type {
        color: var(--basic-labe);
      }

      div {
        p {
          display: inline-block;
          width: 48%;
        }

        p:last-of-type {
          border: none;
          padding-left: 10px;
        }
      }
    }
  }
}

.btnContent {
  padding: 20px 20px 0 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}

.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
